export default function SendIcon(props) {
    return (<svg style={{ cursor: props.disabled ? "initial" : "pointer" }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15">
        <g id="Mask_Group_427" data-name="Mask Group 427" transform="translate(0.334)">
            <path id="send-2" d="M13.3,3.023,6.258,5.363c-4.734,1.583-4.734,4.164,0,5.74l2.09.694.694,2.09c1.575,4.734,4.164,4.734,5.74,0l2.347-7.034c1.045-3.158-.671-4.882-3.829-3.829Zm.25,4.2L10.586,10.2a.584.584,0,0,1-.827,0,.588.588,0,0,1,0-.827l2.963-2.979a.585.585,0,0,1,.827.827Z" transform="translate(-2.708 -2.439)" fill={props.color} />
        </g>
    </svg>
    )
}